import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import {
  AvaliationStep,
  ReportStep,
  DetalingStep,
  DetectionStep,
  InvestigationStep,
  LessonsLearnedStep,
  Stepper,
  TreatmentStep,
  CommunicationEmailStep,
  HighRiskStep,
} from './components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useIncident from 'hooks/useIncident'

import theme from 'theme'
import incidentManegementSteps from 'helpers/incidents/incidentManegementSteps'
import RmcProvider from 'providers/RmcProvider'
import IncidentHighRiskProvider from 'providers/IncidentHighRiskProvider'

import { routes } from 'Routes'
import constants from 'constants/index'

const Form = ({ type, refresh = () => {}, query }) => {
  const {
    handleBack,
    activeStep,
    showButtons,
    activeButton,
    handleAdvanceStep,
    incident,
    wantsToReturnStep,
    handleReturnStep,
    resetReturnStep,
    actionButton,
    setActiveButton,
    isDpo,
    wantsToAdvanceStep,
    isShow,
  } = useIncidentManegement()
  const {
    activeStep: completeFormActiveStep,
    backStep: handleBackCompleteFormStep,
  } = useIncident()
  const history = useHistory()
  const returnToList = () => {
    history.push(routes.incidents.all)
  }

  const steps = incidentManegementSteps(incident, type === 'edit' || isShow)
  const step = steps[activeStep]
  const incidentTypeTest =
    incident?.incidentType === constants.documents.TEST_INCIDENT_VALUE
  const isCreate = type === 'create'
  const isWaitingForDpo =
    isCreate && step === 'avaliation' && !isDpo && !incidentTypeTest

  const stepComponents = {
    detection: <DetectionStep query={query} />,
    investigation: <InvestigationStep />,
    high_risk: (
      <IncidentHighRiskProvider>
        <HighRiskStep refresh={refresh} />
      </IncidentHighRiskProvider>
    ),
    avaliation: <AvaliationStep type={type} refresh={refresh} />,
    detaling: <DetalingStep refresh={refresh} />,
    treatment: (
      <RmcProvider>
        <TreatmentStep refresh={refresh} />
      </RmcProvider>
    ),
    reporting: <ReportStep />,
    communication: <CommunicationEmailStep refresh={refresh} />,
    lessons_learned: <LessonsLearnedStep />,
  }

  const actionButtonText = () => {
    if (isWaitingForDpo || step === 'lessons_learned') {
      return 'Finalizar'
    }

    return 'Avançar'
  }

  useEffect(() => {
    if (isWaitingForDpo) {
      returnToList()
    }
  }, [wantsToAdvanceStep])

  useEffect(() => {
    if (wantsToReturnStep) {
      if (step !== 'high_risk') {
        if (step === 'detaling') {
          if (completeFormActiveStep === 0) {
            handleBack()
          } else {
            refresh()
            handleBackCompleteFormStep()
          }
        } else {
          handleBack()
        }

        resetReturnStep()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToReturnStep])

  useEffect(() => {
    if (type === 'edit' && !isDpo && !incidentTypeTest) {
      if (!incident?.legalOpinion && step === 'avaliation') {
        setActiveButton(false)
      } else if (!actionButton) {
        setActiveButton(true)
      }
    } else {
      if (!actionButton) {
        setActiveButton(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incident, activeStep, actionButton])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stepper type={type} />
      </Grid>

      <Grid item xs={12}>
        <Box mt={3} />

        {stepComponents[step]}
      </Grid>

      {showButtons && (
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={theme.spacing(2)}
          >
            <Button variant="outlined" onClick={handleReturnStep}>
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdvanceStep}
              disabled={wantsToAdvanceStep || !activeButton}
            >
              {actionButtonText()}
            </Button>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}

Form.propTypes = {
  type: PropTypes.string,
  refresh: PropTypes.func,
  query: PropTypes.object,
}

export default Form
